/* =====================================================================
   TRU KAVA tkr · ONE cart controller + ONE drawer + the shared "Build Your Own Ritual Bundle" cards.
   Replaces the approved previews' simulated carts with the real Shopify storefront cart
   (/cart.js, /cart/add.js, /cart/change.js, /cart/update.js).

   Truth rules
   - Every price, discount and total shown in the drawer is Shopify's own number from /cart.js.
     Nothing is discounted in the browser. Card prices on the shopping section show the campaign
     price only while that campaign's window (or the admin override) is active.
   - Checkout pricing is enforced ONLY by Shopify discounts (see release notes). Browser state,
     cart attributes and this script are display + convenience, never enforcement.
   - Promotional shot six-packs are a separate line (property _tkr_gift) and never count toward
     anything. Their quantity is always re-derived from qualifying paid units (Early Sale: exactly 1 at 3+, limit 1 per order).
   - One mutation queue, idempotent reconcile, bounded passes: no update loops, no duplicate adds.
   ===================================================================== */
(function(){
'use strict';
if (window.TKR && window.TKR.__v) return;                          /* one instance per page */
var $ = function(s, r){ return (r || document).querySelector(s); };
var $$ = function(s, r){ return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
function esc(s){ return String(s == null ? '' : s).replace(/[&<>"]/g, function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]; }); }
function cents(c){ return '$' + ((c || 0) / 100).toFixed(2); }
function root(){ return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'; }

var dataEl = document.getElementById('tkr-data');
if (!dataEl) return;
var D; try { D = JSON.parse(dataEl.textContent); } catch(e){ return; }
var CATALOG = D.catalog, IMG = D.img, ELIG = D.eligible;
var byVariant = {}; Object.keys(CATALOG).forEach(function(k){ if (CATALOG[k].variant) byVariant[CATALOG[k].variant] = k; });
var GIFT_PROP = '_tkr_gift', CTX_ATTR = '_tkr_ctx';

/* ---------------- campaign resolution (schedule in exact UTC; admin override; preview-only param) ---------------- */
function resolveCampaign(){
  var ov = D.override || 'auto';
  var role = (window.Shopify && window.Shopify.theme && window.Shopify.theme.role) || D.themeRole || 'main';
  var notLive = role !== 'main';
  if ((notLive || D.designMode) && D.previewParam){
    var m = /[?&]tkr_campaign=([a-z0-9-]+)/.exec(location.search);
    if (m){ try { sessionStorage.setItem('tkr_campaign', m[1]); } catch(e){} }
    try { var sv = sessionStorage.getItem('tkr_campaign'); if (sv) ov = sv; } catch(e){}
  }
  if (ov === 'none') return null;
  if (ov !== 'auto'){ return D.campaigns.filter(function(c){ return c.id === ov; })[0] || null; }
  var now = Date.now();
  return D.campaigns.filter(function(c){ return now >= Date.parse(c.from) && now < Date.parse(c.to); })[0] || null;
}
var C = ('TKR_CAMPAIGN' in window) ? window.TKR_CAMPAIGN : resolveCampaign();   /* same resolver as snippets/tkr-data (single source) */
var PAGE_CTX = document.documentElement.getAttribute('data-tkr-ctx') || 'pub';    /* Starter Kit page sets "acq" */
var ALL_CODES = (function(){ var s = {}; D.campaigns.forEach(function(c){ (c.codes || []).forEach(function(x){ if (x) s[x.trim().toUpperCase()] = 1; }); }); if (D.acqCode) s[D.acqCode.trim().toUpperCase()] = 1; return s; })();
var ACQ = {amount:2500, threshold:3};

function isEligibleKey(k){ return ELIG.indexOf(k) > -1; }
function kindFor(ctx){ return ctx === 'acq' ? 'acq' : (C ? C.kind : 'none'); }

/* ---------------- cart API: one serialized queue ---------------- */
var Q = Promise.resolve(), STATE = {cart:null, busy:0, giftBroken:{}, passes:0};
function req(path, body){
  var opt = {credentials:'same-origin', headers:{'Accept':'application/json','X-Requested-With':'XMLHttpRequest'}};
  if (body){ opt.method = 'POST'; opt.headers['Content-Type'] = 'application/json'; opt.body = JSON.stringify(body); }
  return fetch(root() + path, opt).then(function(r){
    return r.json().catch(function(){ return {}; }).then(function(j){ if (!r.ok){ j.status = r.status; throw j; } return j; });
  });
}
function enqueue(fn){ var p = Q.then(fn, fn); Q = p.catch(function(){}); return p; }
function fetchCart(){ return req('cart.js').then(function(c){ STATE.cart = c; return c; }); }

/* ---------------- model derived from the real cart ---------------- */
function lineKeyOf(l){ return byVariant[l.variant_id] || null; }
function isGift(l){ return !!(l.properties && l.properties[GIFT_PROP]); }
function isSub(l){ return !!l.selling_plan_allocation; }
function model(cart){
  cart = cart || STATE.cart || {items:[]};
  var ctx = (cart.attributes && cart.attributes[CTX_ATTR]) || null;
  var M = {cart:cart, ctx:ctx, paid:[], gifts:[], paidEligibleUnits:0, qualUnits:0, freeUnits:0, items:0};
  var countSubs = !!(C && C.kind === 'pct' && C.giftCountsSubs);
  (cart.items || []).forEach(function(l){
    var k = lineKeyOf(l), g = isGift(l);
    var unit = l.original_price || l.price, disc = (l.original_line_price || 0) - (l.final_line_price || 0);
    var row = {line:l, key:l.key, item:k, qty:l.quantity, gross:l.original_line_price, net:l.final_line_price, disc:disc, sub:isSub(l), gift:g,
               eligible: !!k && isEligibleKey(k) && !isSub(l) && !g, free: unit ? Math.round(disc / unit * 100) / 100 : 0};
    M.items += l.quantity;
    row.qual = !!k && isEligibleKey(k) && !g && (!row.sub || countSubs);      /* gift threshold units: never gifts, kits, presets */
    if (g) M.gifts.push(row); else { M.paid.push(row); if (row.eligible) M.paidEligibleUnits += l.quantity; if (row.qual) M.qualUnits += l.quantity; }
  });
  M.kind = kindFor(ctx || PAGE_CTX);
  M.giftLimit = (C && C.giftLimit) || 0;
  M.giftEarned = M.kind === 'pct' ? (M.giftLimit ? Math.min(Math.floor(M.qualUnits / 3), M.giftLimit) : Math.floor(M.qualUnits / 3)) : 0;
  M.giftWanted = (D.giftEnforced && M.kind === 'pct' && ctx !== 'acq' && C && !STATE.giftBroken[C.giftId]) ? M.giftEarned : 0;
  M.giftHave = M.gifts.reduce(function(s, r){ return s + (C && r.line.properties[GIFT_PROP] === C.giftId && !r.sub ? r.qty : 0); }, 0);
  /* B2G1: free units are read from Shopify's actual allocations; paid = qty - free */
  if (M.kind === 'b2g1'){ M.paid.forEach(function(r){ if (r.eligible){ var f = Math.floor(r.free + 0.001); r.freeUnits = f; M.freeUnits += f; } }); }
  M.b2g1Paid = M.paidEligibleUnits - M.freeUnits;
  return M;
}

/* ---------------- reconcile: context, codes, promotional gifts (idempotent, bounded) ---------------- */
function desiredCodes(ctx){
  if (ctx === 'acq') return D.acqCode ? [D.acqCode.trim()] : [];
  if (ctx === 'pub' && C) return (C.codes || []).map(function(x){ return x.trim(); }).filter(Boolean);
  return [];
}
function reconcile(){
  return enqueue(function(){
    STATE.passes = 0;
    return fetchCart().then(step);
  });
  function step(cart){
    if (STATE.passes++ > 3) return cart;                                 /* hard bound: never loop */
    var M = model(cart), ops = [];
    var empty = !(cart.items || []).length;
    var attrs = cart.attributes || {};
    var current = (cart.discount_codes || []).map(function(d){ return String(d.code).toUpperCase(); });
    var foreign = current.filter(function(c){ return !ALL_CODES[c]; });
    /* 1 · empty cart resets context and our codes */
    if (empty){
      if (attrs[CTX_ATTR]) ops.push(function(){ return req('cart/update.js', {attributes: (function(){ var a = {}; a[CTX_ATTR] = ''; return a; })()}); });
      if (current.length && !foreign.length) ops.push(function(){ return req('cart/update.js', {discount: ''}); });
    } else {
      /* 2 · the first eligible regular product establishes context; the Starter Kit never does */
      if (!attrs[CTX_ATTR] && M.paidEligibleUnits > 0){
        var ctx = PAGE_CTX === 'acq' ? 'acq' : 'pub';
        ops.push(function(){ var a = {}; a[CTX_ATTR] = ctx; return req('cart/update.js', {attributes:a}); });
      }
      var useCtx = attrs[CTX_ATTR] || (M.paidEligibleUnits > 0 ? (PAGE_CTX === 'acq' ? 'acq' : 'pub') : null);
      /* 3 · campaign / acquisition codes (only when the shop configured codes; never overwrite a customer's own code) */
      if (useCtx && !foreign.length){
        var wantCodes = desiredCodes(useCtx).map(function(x){ return x.toUpperCase(); }).sort().join(','), haveCodes = current.slice().sort().join(',');
        if (wantCodes !== haveCodes) ops.push(function(){ return req('cart/update.js', {discount: desiredCodes(useCtx).join(',')}); });
      }
      /* 4 · promotional gift lines: remove stale campaign gifts, then set exact earned quantity */
      M.gifts.forEach(function(r){ if (!C || r.line.properties[GIFT_PROP] !== C.giftId || r.sub || M.kind !== 'pct' || useCtx === 'acq') ops.push(function(){ return req('cart/change.js', {id:r.key, quantity:0}); }); });
      if (M.kind === 'pct' && useCtx !== 'acq' && C){
        var mine = M.gifts.filter(function(r){ return r.line.properties[GIFT_PROP] === C.giftId && !r.sub; });
        mine.slice(1).forEach(function(r){ ops.push(function(){ return req('cart/change.js', {id:r.key, quantity:0}); }); });  /* never duplicate lines */
        var wantGift = M.giftWanted, giftV = CATALOG[C.gift] && CATALOG[C.gift].variant;
        if (mine.length && mine[0].qty !== wantGift) ops.push(function(){ return req('cart/change.js', {id:mine[0].key, quantity:wantGift}); });
        if (!mine.length && wantGift > 0 && giftV){ var pr = {}; pr[GIFT_PROP] = C.giftId; ops.push(function(){ return req('cart/add.js', {items:[{id:giftV, quantity:wantGift, properties:pr}]}).catch(function(err){ STATE.giftNote = (err && err.description) || 'The free shot six-pack is temporarily unavailable.'; }); }); }
      }
    }
    if (!ops.length){ verifyGiftPricing(cart); return cart; }
    return ops.reduce(function(p, op){ return p.then(op); }, Promise.resolve()).then(fetchCart).then(step);
  }
}
/* if Shopify did not price the promotional line at $0 (offer not live at checkout), remove it and stop re-adding this session.
   Subscription shot lines are skipped: they never carry the campaign discount. */
function verifyGiftPricing(cart){
  if (!C || C.kind !== 'pct') return;
  var M = model(cart), shotV = CATALOG[C.gift] && CATALOG[C.gift].cents; if (!shotV || !M.giftHave) return;
  var freeValue = 0; (cart.items || []).forEach(function(l){ if (l.variant_id === CATALOG[C.gift].variant && !isSub(l)){ freeValue += (l.original_line_price - l.final_line_price) - (isGift(l) ? 0 : Math.round(l.original_line_price * (C.pct / 100))); } });
  if (freeValue + 2 < M.giftHave * shotV){
    STATE.giftBroken[C.giftId] = true;
    STATE.giftNote = 'The free shot six-pack offer isn’t active at checkout right now, so it hasn’t been added.';
    reconcile();
  }
}

/* ---------------- public API (page scripts: Starter Kit, collections, PDP forms) ---------------- */
function add(items, btn, errEl){
  if (btn && btn.getAttribute('aria-busy') === 'true') return Promise.resolve(false);
  var label = btn ? btn.innerHTML : '';
  if (btn){ btn.setAttribute('aria-busy', 'true'); btn.disabled = true; btn.textContent = 'Adding…'; }
  if (errEl){ errEl.hidden = true; errEl.textContent = ''; }
  var before = STATE.cart ? model() : null;
  return enqueue(function(){ return req('cart/add.js', {items:items}); })
    .then(function(){ return reconcile(); })
    .then(function(){
      var it = items[0], k = byVariant[it.id], p = k ? CATALOG[k] : null;
      var msg = 'Added to your cart: ' + (p ? p.name + ', ' + p.pack : 'item') + '.' + rewardDelta(before, model());
      if (cd.hidden) openCart(btn, msg); else { draw(btn && btn.closest('#cdRecs') ? '#cdRecs' : null); say(msg); }
      return true;
    })
    .catch(function(err){
      var d = (err && (err.description || err.message)) || '';
      var name = (function(){ var k = byVariant[items[0].id]; return k ? CATALOG[k].name : 'this item'; })();
      var t = 'Sorry, we couldn’t add ' + name + '. ' + (d && /stock|available|sold/i.test(d) ? d : 'Nothing was added; please try again.');
      if (errEl){ errEl.textContent = t; errEl.hidden = false; } else say(t);
      return false;
    })
    .then(function(ok){ if (btn && document.contains(btn)){ btn.removeAttribute('aria-busy'); btn.disabled = false; btn.innerHTML = label; } draw(); return ok; });
}
function setQty(lineKey, q){
  var before = model();
  return enqueue(function(){ return req('cart/change.js', {id:lineKey, quantity:q}); })
    .then(function(){ return reconcile(); })
    .then(function(){ return rewardDelta(before, model()); })
    .catch(function(err){ say((err && err.description) || 'Sorry, that change didn’t go through. Your cart hasn’t changed.'); return ''; });
}
function rewardDelta(B, A){
  if (!B) return '';
  var out = [];
  if (A.kind === 'pct'){
    var gb = B.giftHave, ga = A.giftHave;
    if (ga > gb) out.push(ga + ' FREE shot six-pack' + (ga === 1 ? '' : 's') + ' unlocked.');
    else if (ga < gb){ var nb = A.giftLimit ? Math.max(1, 3 - A.qualUnits) : 3 - A.qualUnits % 3; out.push(ga ? 'Now ' + ga + ' FREE shot six-pack' + (ga === 1 ? '' : 's') + '.' : 'Free shot six-pack removed: add ' + nb + ' more eligible pack' + (nb === 1 ? '' : 's') + ' to get it back.'); }
  } else if (A.kind === 'b2g1'){
    if (A.freeUnits > B.freeUnits) out.push('Buy 2, get 1 FREE: ' + A.freeUnits + ' free pack' + (A.freeUnits === 1 ? '' : 's') + ' in your cart.');
    var rb = B.b2g1Paid >= 3, ra = A.b2g1Paid >= 3;
    if (ra && !rb) out.push('You’ve earned $25 off your next order. Issued after fulfillment.');
    if (!ra && rb) out.push('$25 next-order reward no longer qualifies.');
  }
  var sb = (B.cart.total_price || 0) >= D.freeShipCents, sa = (A.cart.total_price || 0) >= D.freeShipCents;
  if (sa !== sb && (A.cart.items || []).length) out.push(sa ? 'Free U.S. shipping threshold reached.' : 'Below the free U.S. shipping threshold.');
  return out.length ? ' ' + out.join(' ') : '';
}

/* ---------------- shared shopping cards (approved V11 markup, real data) ---------------- */
var FORMATS = [
  {fam:'powder', k:'Anytime, Anywhere', title:'Instant Kava Sachets', items:['box1'], img:'g1', pos:'50% 50%',
   alt:'TRU KAVA Tropical Citrus instant kava sachet and box beside a mixed glass',
   d:'Lightweight sachets for home, travel and social plans. Pocket-sized kava to mix with water, juice or a smoothie.'},
  {fam:'drinks', k:'Dinners & Gatherings', title:'Sparkling Kava Drinks', items:['drink_tc','drink_gb'], legend:'Flavor', img:'pour_d', pos:'50% 60%',
   alt:'TRU KAVA sparkling kava cans, one pouring into a glass',
   d:'An alcohol-free option for dinner parties, entertaining and relaxed evenings at home. Keep a few chilled for your next gathering.'},
  {fam:'shots', k:'Life on the Move', title:'TRU KAVA Shots', items:['shots'], img:'shot', pos:'50% 12%',
   alt:'TRU KAVA Tropical Citrus shot bottle on a beach',
   d:'A compact companion for workdays, outdoor events and travel. Keep one handy for a pause between plans.'},
  {fam:'oils', k:'Your Daily Foundation', title:'KAVAPLEX Oils', items:['oil_kp','oil_mind'], legend:'Oil', img:'oil', pos:'50% 45%',
   alt:'TRU KAVA KAVAPLEX kava oil dropper bottle',
   d:'A whole-food kava oil that fits alongside your daily foods and supplements. Add it to coffee, tea or a smoothie.'}
];
var RECS = {
  order: {powder:['drink_tc','shots','oil_kp'], drinks:['shots','oil_kp','box1'], shots:['drink_tc','oil_kp','box1'], oils:['drink_tc','shots','box1'], none:['box1','drink_tc','shots']},
  why: {drink_tc:'Ready to drink with no mixing, for dinners and gatherings.', shots:'A compact 2 oz shot that is easy to carry when you travel.',
        oil_kp:'One dropper under the tongue, or stirred into coffee or tea.', box1:'Single-serve sachets to mix with water, juice or a smoothie, at home or away.',
        kit:'Three boxes, 36 sachets and the 30-Day Kava Ritual Guide.'}
};
var CAMP_PARAMS = (function(){ var out = []; try { new URLSearchParams(location.search).forEach(function(v, k){ if (/^(utm_[a-z]+|campaign|gclid|fbclid|ttclid|irclickid|rfsn)$/i.test(k)) out.push([k, v]); }); } catch(e){} return out; })();
function withCampaign(url){
  if (!url || !CAMP_PARAMS.length) return url;
  try { var u = new URL(url, location.origin); if (u.origin !== location.origin) return url; CAMP_PARAMS.forEach(function(p){ if (!u.searchParams.has(p[0])) u.searchParams.set(p[0], p[1]); }); return u.pathname + u.search + u.hash; } catch(e){ return url; }
}
function shopKind(){ return PAGE_CTX === 'acq' ? 'acq' : (C ? C.kind : 'none'); }
function unitNet(k){ var p = CATALOG[k]; return (shopKind() === 'pct' && isEligibleKey(k)) ? Math.round(p.cents * (100 - C.pct) / 100) : p.cents; }
function priceHTML(k){
  var p = CATALOG[k], sk = shopKind();
  if (sk === 'pct' && isEligibleKey(k)) return '<span class="sr">Regular price </span><s>' + cents(p.cents) + '</s><span class="sr">, sale price </span><b>' + cents(unitNet(k)) + '</b> <em class="byr-off">' + C.pct + '% off</em>';
  if (sk === 'b2g1' && isEligibleKey(k)) return '<b>' + cents(p.cents) + '</b> <em class="byr-off">Buy 2, get 1 free</em>';
  return '<b>' + cents(p.cents) + '</b>';
}
function addLabel(k){
  var p = CATALOG[k], sk = shopKind();
  if (sk === 'pct' && isEligibleKey(k)) return 'Add ' + p.name + ', ' + p.pack + ', ' + cents(unitNet(k)) + ' after ' + C.pct + '% off ' + cents(p.cents) + ', to cart';
  return 'Add ' + p.name + ', ' + p.pack + ', ' + cents(p.cents) + ', to cart' + (sk === 'b2g1' && isEligibleKey(k) ? '. Buy 2, get 1 free on matching packs.' : '');
}
function firstAvail(f){ return f.items.filter(function(k){ return CATALOG[k] && CATALOG[k].ok; })[0] || f.items[0]; }
function pageImage(f, k){
  var p = CATALOG[k] || {}, ik = p.pageImg || f.img, pos = p.pageImg ? (p.pagePos || '50% 50%') : f.pos, alt = p.pageImg ? p.pageAlt : f.alt;
  return '<img src="' + esc(IMG[ik] || '') + '" alt="' + esc(alt) + '" style="object-position:' + pos + '" loading="lazy" width="700" height="600">';
}
function addBtn(k){ var p = CATALOG[k]; return p.available ? '<button class="btn btn-gold byr-btn" type="button" data-add aria-label="' + esc(addLabel(k)) + '">+ Add to Cart</button>' : '<button class="btn btn-gold byr-btn" type="button" data-add disabled aria-label="' + esc(p.name) + ' is sold out">Sold out</button>'; }
function cardHTML(f){
  var key = firstAvail(f), first = CATALOG[key];
  var slot = f.items.length > 1
    ? '<fieldset class="byr-slot byr-opts"><legend class="sr">' + esc(f.legend) + ' for ' + esc(f.title) + '</legend>' + f.items.map(function(k){
        return '<label><input type="radio" name="byr-' + f.fam + '" value="' + k + '"' + (k === key ? ' checked' : '') + (CATALOG[k].ok ? '' : ' disabled') + '><span>' + esc(CATALOG[k].opt) + '</span></label>'; }).join('') + '</fieldset>'
    : '<p class="byr-slot byr-fact">' + esc(first.opt) + '</p>';
  return '<article class="byr-card" data-fam="' + f.fam + '" data-item="' + key + '">' +
    '<div class="byr-im">' + pageImage(f, key) + '</div>' +
    '<p class="byr-k">' + esc(f.k) + '</p><h3><a data-more data-title href="' + esc(withCampaign(first.url)) + '">' + esc(first.cardTitle || f.title) + '</a></h3><p class="byr-d" data-desc>' + esc(first.cardDesc || f.d) + '</p>' + slot +
    '<p class="byr-p"><span data-pack>' + esc(first.pack) + '</span><span class="byr-pr" data-price>' + priceHTML(key) + '</span></p>' +
    '<div class="byr-act" data-act>' + addBtn(key) +
    '<a class="byr-more" data-more href="' + esc(withCampaign(first.url)) + '">Product details<span class="sr"> for ' + esc(first.name) + '</span></a>' +
    '<p class="byr-err" role="alert" hidden></p></div></article>';
}
function fmtOf(card){ return FORMATS.filter(function(f){ return f.fam === card.getAttribute('data-fam'); })[0]; }
/* one routine updates every product-specific field; cart lines keep their own variant, so switching never alters the cart */
function selectCardItem(card, key){
  var f = fmtOf(card), p = CATALOG[key];
  card.setAttribute('data-item', key);
  $('[data-title]', card).textContent = p.cardTitle || f.title;
  $('[data-desc]', card).textContent = p.cardDesc || f.d;
  $('[data-pack]', card).textContent = p.pack;
  $('[data-price]', card).innerHTML = priceHTML(key);
  var im = $('.byr-im img', card), ik = p.pageImg || f.img;                       /* lifestyle only, never the cart photograph */
  im.src = IMG[ik] || ''; im.alt = p.pageImg ? p.pageAlt : f.alt; im.style.objectPosition = p.pageImg ? (p.pagePos || '50% 50%') : f.pos;
  $$('[data-more]', card).forEach(function(a){ a.href = withCampaign(p.url); });
  var sr = $('.byr-more .sr', card); if (sr) sr.textContent = ' for ' + p.name;
  var act = $('[data-act]', card), old = $('[data-add]', act); old.outerHTML = addBtn(key);
  $$('input[type=radio]', card).forEach(function(x){ x.checked = x.value === key; });
}
function offerDetails(){
  var sk = shopKind(), L = [];
  if (sk === 'pct') L = [
    C.pct + '% off eligible one-time products, with no minimum quantity.',
  ].concat(C.giftLimit === 1 ? [
    'Buy 3 or more eligible packs, get 1 free shots six-pack. Limit 1 gift per order.',
    'Mix formats or repeat your favorites. 6, 9 or more eligible packs still earn one free six-pack.',
    C.giftCountsSubs ? 'One-time packs and new subscription packs can be combined toward the 3. The ' + C.pct + '% applies to one-time packs only; subscriptions keep their regular subscription pricing, and subscription renewals never receive the gift.' : 'Only one-time packs count toward the 3. Subscriptions keep their regular subscription pricing and aren’t part of the sale.'
  ] : [
    'Get one free shot six-pack for every 3 eligible paid products. Mix formats or repeat your favorites.',
    '3 products earn 1 free six-pack, 6 earn 2 and 9 earn 3. There’s no limit per order.'
  ]).concat([
    'Each retail pack counts as one product: one regular powder box, one sparkling drink six-pack, one shot six-pack or one oil bottle. Individual sachets, cans and shots inside retail packs don’t count separately.',
    'Free six-packs don’t count toward further rewards or toward free shipping, and are added as a separate $0.00 line.',
    'The free shot six-pack combines with the ' + C.pct + '% discount. No other discounts or promotions combine with this offer.',
    'Excluded, and not discounted: acquisition kits (including the 3-Box Ritual Starter Kit), ' + (C.giftLimit === 1 && C.giftCountsSubs ? 'subscription renewals' : 'subscriptions and renewals') + ', discounted preset bundles, gift cards and free promotional items. Excluded bundles don’t count toward the free six-pack, whatever they contain.',
    'Free U.S. shipping on qualifying orders of $125+ after discounts. Free six-packs, shipping and taxes don’t count toward it. Otherwise, shipping and applicable taxes are calculated at checkout.',
    C.copy.dates]);
  else if (sk === 'b2g1') L = [
    'Buy 2, get 1 FREE: buy two eligible retail packs of the same product and variant and get a third matching pack free. It repeats for each complete group of three matching packs: 3 packs, pay for 2; 6 packs, pay for 4.',
    'Different flavors and oils don’t combine. KAVAPLEX and KAVAPLEX MIND are separate products. No additional percentage discount applies.',
    'PLUS, buy 3 paid eligible products in one order and earn $25 off your next order. Mix formats or repeat a product. Free Buy 2, Get 1 packs don’t count toward the 3.',
    'The $25 reward is not applied to the order that earns it. One reward per qualifying order. Issued after fulfillment and valid for 60 days from issuance. Single use, no minimum, for a future one-time purchase; no cash value and doesn’t combine with other promotions.',
    'Excluded: subscriptions and renewals, acquisition kits (including the 3-Box Ritual Starter Kit), discounted preset bundles, gift cards and free promotional items. No other discounts or promotions combine with this offer.',
    'Free U.S. shipping on qualifying orders of $125+ after discounts. Free packs, shipping and taxes don’t count toward it. Otherwise, shipping and applicable taxes are calculated at checkout.',
    C.copy.dates];
  else if (sk === 'acq') L = [
    'Mix formats or repeat a favorite: any 3 eligible regular one-time packs qualify (drink 6-packs, shot 6-packs, KAVAPLEX oils or single powder boxes).',
    'Three eligible packs unlock $25 off your current order.',
    'The saving applies once per order: 6 eligible packs still save $25.',
    'The special 3-Box Ritual Starter Kit is excluded and does not count toward the 3 packs; its price applies to the kit only.',
    'Does not combine with other promotions; if another automatic discount is larger, that one applies instead.'];
  return L;
}
function drawShop(){
  var grid = $('#byrGrid'); if (!grid) return;
  var sk = shopKind(), root = grid.closest('.tkr');
  if (root) root.setAttribute('data-kind', sk);
  grid.innerHTML = FORMATS.map(cardHTML).join('');
  var off = $('#byrOffer');
  if (off){
    var any = false;
    $$('[data-tkr-offer]', off).forEach(function(el){ var on = el.getAttribute('data-tkr-offer') === sk; el.hidden = !on; any = any || on; });
    off.hidden = !any;
    var ul = $('#offerList'); if (ul) ul.innerHTML = offerDetails().map(function(x){ return '<li>' + esc(x) + '</li>'; }).join('');
  }
  if (!grid.__tkr){
    grid.__tkr = 1;
    grid.addEventListener('change', function(e){ var r = e.target; if (r.type !== 'radio') return; selectCardItem(r.closest('.byr-card'), r.value); });
    grid.addEventListener('click', function(e){
      var b = e.target.closest('[data-add]'); if (!b || b.disabled) return;
      var card = b.closest('.byr-card'), k = card.getAttribute('data-item');
      add([{id:CATALOG[k].variant, quantity:1}], b, $('.byr-err', card));         /* always one-time */
    });
  }
}
function applyCopy(){
  if (!C) { document.documentElement.setAttribute('data-tkr-campaign', 'none'); return; }
  $$('[data-camp="label"]').forEach(function(el){ el.textContent = C.copy.label; });
  $$('[data-camp="full"]').forEach(function(el){ el.textContent = C.copy.full; });
  $$('[data-camp="announce"]').forEach(function(el){ el.textContent = C.copy.announce; });
  if (C.pct) $$('[data-camp="pctline"]').forEach(function(el){ el.textContent = C.pct + '% off eligible one-time products'; });
  document.documentElement.setAttribute('data-tkr-campaign', C.id);
}

/* ---------------- drawer (approved V11 behaviour) ---------------- */
var cd = $('#cartDrawer'); if (!cd) return;
var cdPanel = $('.cd-panel', cd), cdBody = $('.cd-body', cd), cdOpener = null;
function thumbFor(row){
  var p = row.item && CATALOG[row.item], src = p && p.cartImg && IMG[p.cartImg];
  if (!src && row.line && row.line.image) src = row.line.image;
  return src ? '<img class="cd-th" src="' + esc(src) + '" alt="">' : '<span class="cd-th ph" aria-hidden="true">' + esc(p ? (p.opt || p.name) : row.line.product_title) + '</span>';
}
function thumbKey(k){ var p = CATALOG[k], src = p.cartImg && IMG[p.cartImg]; return src ? '<img class="cd-th" src="' + esc(src) + '" alt="">' : '<span class="cd-th ph" aria-hidden="true">' + esc(p.opt || p.name) + '</span>'; }
function famsInCart(M){ var f = {}; M.paid.forEach(function(r){ if (r.item) f[CATALOG[r.item].fam] = 1; }); return f; }
function recList(M){
  var fams = famsInCart(M), keys = Object.keys(fams), out = [];
  (keys.length ? keys : ['none']).forEach(function(f){ (RECS.order[f] || []).forEach(function(k){ if (out.indexOf(k) < 0) out.push(k); }); });
  out = out.filter(function(k){ return CATALOG[k] && CATALOG[k].ok && CATALOG[k].available && !fams[CATALOG[k].fam]; });
  /* Starter Kit page: the kit leads the recommendations until it is in the cart (added with the plan selected in the buy box) */
  var kitIn = M.paid.some(function(r){ return r.item === 'kit'; });
  if (PAGE_CTX === 'acq' && CATALOG.kit && CATALOG.kit.ok && CATALOG.kit.available && !kitIn && window.TKR && TKR.hooks && TKR.hooks.kitItem) out.unshift('kit');
  return out.slice(0, 3);
}
var CUE_HTML = '<button class="cd-cue cd-cue-line" type="button" data-cue-go aria-controls="cdRecs"><span class="cd-cue-t">Complete Your Ritual</span><span class="cd-cue-a" aria-hidden="true">↓</span></button>';
var cueMQ = window.matchMedia('(max-width:640px)');
function cueState(has){ cdPanel.setAttribute('data-cue', !has || !cueMQ.matches ? 'none' : 'line'); if (has && cueMQ.matches && !cd.hidden) cueFit(); }
function cueFit(){
  var c = $('.cd-line.has-cue .cd-cue', cd);
  if (cdPanel.getAttribute('data-cue') === 'none' || !c) return;
  cdPanel.setAttribute('data-cue', 'line');
  var br = cdBody.getBoundingClientRect(), bottom = c.getBoundingClientRect().bottom - br.top + cdBody.scrollTop;
  if (bottom > cdBody.clientHeight - 6) cdPanel.setAttribute('data-cue', 'row');
}
function cueGo(){
  var top = cdBody.scrollTop + $('#cdRecs').getBoundingClientRect().top - cdBody.getBoundingClientRect().top;
  cdBody.scrollTo({top:top, behavior: reduce ? 'auto' : 'smooth'});
  var h = $('#cdRecH'); h.setAttribute('tabindex', '-1'); h.focus({preventScroll:true});
}
function setText(el, t){ if (el && el.textContent !== t) el.textContent = t; }
function relTop(el){ return el.getBoundingClientRect().top - cdBody.getBoundingClientRect().top; }
function say(msg){ var m = $('#cdMsg'); if (m) m.textContent = msg || ''; }
/* recurring price after the first order, from the selling plan's own price adjustments (Skio-configured) */
function renewalCents(p, pl){
  if (!p || !pl || !pl.adj || pl.adj.length < 2) return 0;
  var a = pl.adj.filter(function(x){ return x.pos === 2; })[0] || pl.adj[1];
  if (a.type === 'price') return a.value;
  if (a.type === 'percentage') return Math.round(p.cents * (100 - a.value) / 100);
  if (a.type === 'fixed_amount') return p.cents - a.value;
  return 0;
}
function planText(row, M){
  var l = row.line;
  if (row.sub){
    var sp = l.selling_plan_allocation.selling_plan, p = row.item && CATALOG[row.item], pl = p && (p.plans || []).filter(function(x){ return x.id === sp.id; })[0], ren = renewalCents(p, pl);
    return '<p class="cd-plan"><b>Subscription</b> · ' + esc(sp.name) + (ren ? ' · then ' + cents(ren) + ' per delivery' : '') + '</p>';
  }
  if (!row.eligible) return '<p class="cd-plan once">One-time purchase</p>';
  var sfx = M.kind === 'pct' && C ? ' · ' + C.pct + '% off' : M.kind === 'b2g1' ? ' · Buy 2, get 1 FREE' : '';
  return '<p class="cd-plan once">One-time purchase' + sfx + '</p>';
}
function draw(anchor){
  var st = cdBody.scrollTop, a = anchor && $(anchor, cd), aTop = a ? relTop(a) : null;
  var M = model(), cart = M.cart, n = cart.item_count || 0, empty = !(cart.items || []).length;
  $$('[data-cart-count],[data-tk27-cart-count]').forEach(function(el){ el.textContent = n; el.classList.toggle('on', n > 0); if (el.hasAttribute('data-tk27-cart-count')) el.hidden = !n; });
  $$('[data-cart-open]').forEach(function(b){ b.setAttribute('aria-label', 'Open cart, ' + n + (n === 1 ? ' item' : ' items')); });
  setText($('#cdCount'), '(' + n + (n === 1 ? ' item' : ' items') + (M.kind === 'b2g1' && M.freeUnits ? ' · ' + M.freeUnits + ' free' : '') + ')');
  $('#cdEmpty').hidden = !empty; $('#cdShip').hidden = empty; $('#cdFt').hidden = empty; $('#cdRecs').hidden = empty;
  /* shipping progress: Shopify's discounted total (gifts are $0 so add nothing) */
  var thr = D.freeShipCents, q = cart.total_price || 0, left = Math.max(0, thr - q);
  setText($('#cdShipT'), left > 0 ? 'You’re ' + cents(left) + ' away from free U.S. shipping.' : 'You’ve reached free U.S. shipping.');
  setText($('#cdShipN'), 'Qualifying U.S. orders of $125+ after discounts.' + (M.kind === 'pct' ? ' The free gift doesn’t count.' : M.kind === 'b2g1' ? ' Free packs don’t count.' : '') + ' Eligibility confirmed at checkout.');
  $('#cdBar').style.width = Math.min(100, q / thr * 100) + '%';
  $('#cdShip .cd-bar').setAttribute('aria-valuenow', (Math.min(thr, q) / 100).toFixed(2));
  /* gift discount value is shown on the gift line; any allocation Shopify placed on a paid shot unit is moved there for display only (totals unchanged) */
  var giftQty = M.giftHave, giftUnit = C && C.gift && CATALOG[C.gift] ? CATALOG[C.gift].cents : 0, giftFreeOk = false, shift = 0;
  if (giftQty && C){
    var giftLine = M.gifts.filter(function(r){ return r.line.properties[GIFT_PROP] === C.giftId; })[0];
    var need = giftQty * giftUnit, onGift = giftLine ? giftLine.disc : 0;
    shift = Math.max(0, need - onGift);
    var avail = 0; M.paid.forEach(function(r){ if (r.item === C.gift && !r.sub) avail += r.disc - Math.round(r.gross * C.pct / 100); });
    giftFreeOk = onGift + Math.max(0, avail) + 2 >= need;
  }
  var rows = M.paid.map(function(r){
    var d = r.disc;
    if (shift && r.item === (C && C.gift) && !r.sub){ var mv = Math.min(shift, Math.max(0, d - Math.round(r.gross * C.pct / 100))); d -= mv; shift -= mv; }
    return {r:r, disc:d, net:r.gross - d};
  });
  $('#cdLines').innerHTML = rows.map(function(x, li){
    var r = x.r, p = r.item ? CATALOG[r.item] : null, nm = p ? p.name : r.line.product_title, pk = p ? p.pack : (r.line.variant_title || '');
    var status = '', prompt = '', lbl = '';
    if (M.kind === 'b2g1' && r.eligible){
      if (r.freeUnits) status = '<p class="cd-b2s"><b>' + r.freeUnits + ' free</b> · ' + r.qty + ' packs, you pay for ' + (r.qty - r.freeUnits) + '</p>';
      if (r.qty % 3 === 2) prompt = '<button class="cd-b2" type="button" data-q="1" aria-label="Add one more matching pack of ' + esc(nm) + '. It’s free.">Add one more matching pack—it’s free.</button>';
      lbl = r.freeUnits ? '<span class="cd-ld free"> ' + r.freeUnits + ' free</span>' : '';
    } else if (x.disc && M.kind === 'pct' && C && r.eligible) lbl = '<span class="cd-ld"> ' + C.pct + '% off</span>';
    var price = x.disc > 0 ? '<s><span class="sr">Regular </span>' + cents(r.gross) + '</s>' + cents(x.net) + lbl : cents(r.gross);
    return '<li class="cd-line' + (li === 0 ? ' has-cue' : '') + '" data-key="' + esc(r.key) + '">' + thumbFor(r) + (li === 0 ? CUE_HTML : '') +
      '<div><p class="cd-nm">' + esc(nm) + '</p><p class="cd-var">' + esc(pk) + '</p>' + planText(r, M) +
      '<div class="cd-row"><span class="cd-qty"><button type="button" data-q="-1" aria-label="Decrease quantity of ' + esc(nm) + '"' + (r.qty <= 1 ? ' disabled' : '') + '>−</button>' +
      '<output aria-label="Quantity of ' + esc(nm) + '">' + r.qty + '</output><button type="button" data-q="1" aria-label="Increase quantity of ' + esc(nm) + '">+</button></span>' +
      '<button class="cd-rm" type="button" data-rm aria-label="Remove ' + esc(nm) + '">Remove</button>' +
      '<span class="cd-lt">' + price + '</span></div>' + status + prompt +
      (p ? '<p class="cd-unit">' + esc(p.unit) + '</p>' : '') + '</div></li>';
  }).join('') + (giftQty ? '<li class="cd-line cd-gift" data-gift="' + esc(C.giftId) + '" data-gift-qty="' + giftQty + '">' + thumbKey(C.gift) +
      '<div><p class="cd-nm">FREE TRU KAVA Shots</p><p class="cd-var"><span class="cd-gq">' + giftQty + ' six-pack' + (giftQty === 1 ? '' : 's') + '</span> · ' + (giftQty * 6) + ' shots</p>' +
      '<p class="cd-gtag">' + (M.giftLimit === 1 ? 'Limit 1 free six-pack per order' : '1 free six-pack for every 3 eligible products') + ' · not counted toward offers or free shipping</p>' +
      '<div class="cd-row"><span class="sr">Promotional gift, quantity ' + giftQty + '</span><span class="cd-lt">' + (giftFreeOk ? '$0.00' : cents(giftQty * giftUnit)) + '</span></div></div></li>' : '') +
      (STATE.giftNote ? '<li class="cd-line"><div></div><div><p class="cd-unit">' + esc(STATE.giftNote) + '</p></div></li>' : '');
  /* discounts exactly as Shopify applied them (grouped by title); gift shown once at $0 */
  var groups = {}, order = [];
  (cart.items || []).forEach(function(l){ (l.line_level_discount_allocations || []).forEach(function(al){ var t = (al.discount_application && al.discount_application.title) || 'Discount'; if (!groups[t]){ groups[t] = 0; order.push(t); } groups[t] += al.amount; }); });
  (cart.cart_level_discount_applications || []).forEach(function(ap){ var t = ap.title || 'Discount'; if (!groups[t]){ groups[t] = 0; order.push(t); } groups[t] += ap.total_allocated_amount; });
  var giftValue = giftQty && giftFreeOk ? giftQty * giftUnit : 0, html = '';
  var otherTotal = order.reduce(function(s, t){ return s + groups[t]; }, 0) - giftValue;
  if (M.kind === 'pct' && C && otherTotal > 0) html += '<p class="cd-dl"><span>' + esc((C.family === 'bf30' ? 'Black Friday' : C.copy.saleName) + ' · ' + C.pct + '% off eligible products') + '</span><span>−' + cents(otherTotal) + '</span></p>';
  else if (M.kind === 'b2g1' && otherTotal > 0) html += '<p class="cd-dl"><span>Buy 2, get 1 FREE · ' + M.freeUnits + ' free pack' + (M.freeUnits === 1 ? '' : 's') + '</span><span>−' + cents(otherTotal) + '</span></p>';
  else if (otherTotal > 0) order.forEach(function(t){ html += '<p class="cd-dl"><span>' + esc(t) + '</span><span>−' + cents(groups[t]) + '</span></p>'; });
  if (giftValue) html += '<p class="cd-dl gift"><span>FREE shot six-pack' + (giftQty === 1 ? '' : 's') + ' × ' + giftQty + '</span><span>$0.00</span></p>';
  $('#cdDisc').innerHTML = html;
  setText($('#cdSubL'), M.kind === 'b2g1' ? 'Subtotal due today' : 'Subtotal');
  setText($('#cdSub'), cents(cart.total_price));
  var anySub = M.paid.some(function(r){ return r.sub; });
  setText($('#cdRecur'), anySub ? 'Subscriptions renew automatically until canceled. Skip, pause or cancel anytime from your account.' : '');
  /* ONE reward indicator */
  var off = $('#cdOffer'), show = !empty && (M.kind === 'pct' || M.kind === 'b2g1' || M.kind === 'acq');
  off.hidden = !show;
  if (show){
    var fill, title, note, done;
    if (M.kind === 'pct'){
      var pu = M.qualUnits, earned = M.giftEarned, cyc = pu % 3, need = M.giftLimit ? Math.max(0, 3 - pu) : 3 - cyc; done = earned > 0;
      fill = M.giftLimit ? Math.min(pu, 3) : (earned && !cyc ? 3 : cyc);
      function prods(k, more){ return k + (more ? ' more' : '') + ' eligible pack' + (k === 1 ? '' : 's'); }
      title = earned ? (M.giftLimit === 1 ? 'FREE shot six-pack unlocked.' : earned + ' FREE shot six-pack' + (earned === 1 ? '' : 's') + ' unlocked.') : 'Add ' + prods(need, pu > 0) + ' to unlock your FREE shot six-pack.';
      note = M.giftLimit === 1 ? (earned ? 'Limit 1 gift per order.' : (C && C.giftCountsSubs ? 'Mix one-time and new subscription packs.' : 'Mix formats or repeat a favorite.')) : (earned ? 'Add ' + prods(need, true) + ' to unlock another.' : 'Mix formats or repeat a favorite.');
    } else if (M.kind === 'b2g1'){
      var pp = M.b2g1Paid, nd = 3 - pp; fill = Math.min(pp, 3); done = pp >= 3;
      title = nd <= 0 ? 'You’ve earned $25 off your next order.' : pp === 0 ? 'Buy 3 paid products to earn $25 off your next order.' : 'Add ' + nd + ' more paid product' + (nd === 1 ? '' : 's') + ' to earn $25 off your next order.';
      note = pp + ' paid product' + (pp === 1 ? '' : 's') + (M.freeUnits ? ' + ' + M.freeUnits + ' free' : '') + ' in your cart. ' + (done ? 'Issued after fulfillment. Not applied to today’s order.' : 'Free packs don’t count. Not applied to today’s order.');
    } else {
      var au = M.paidEligibleUnits; fill = Math.min(au, 3); done = au >= 3;
      title = done ? 'Your $25 bundle saving is applied.' : au === 2 ? 'Add 1 more eligible pack to save $25.' : au === 1 ? 'Add 2 more eligible packs to save $25.' : 'Add 3 eligible packs to save $25.';
      note = 'The Starter Kit doesn’t count toward the 3.';
      if (done){ var applied = (cart.discount_codes || []).some(function(dc){ return D.acqCode && dc.code.toUpperCase() === D.acqCode.toUpperCase() && dc.applicable; }); if (!applied) title = 'Your $25 bundle saving is confirmed at checkout.'; }
    }
    $$('.cd-seg i', off).forEach(function(seg, i){ seg.classList.toggle('on', i < fill); });
    setText($('#cdOfferT'), title); setText($('#cdOfferN'), note);
    off.setAttribute('data-state', done ? 'done' : 'progress');
  }
  var recs = recList(M);
  $('#cdRecList').hidden = !recs.length;
  $('#cdRecList').innerHTML = recs.map(function(k){
    var p = CATALOG[k], net = (M.kind === 'pct' && C && M.ctx !== 'acq' && isEligibleKey(k)) ? Math.round(p.cents * (100 - C.pct) / 100) : p.cents;
    if (k === 'kit'){ var ki = TKR.hooks.kitItem(), pl = ki.selling_plan && (p.plans || []).filter(function(x){ return x.id === ki.selling_plan; })[0]; if (pl) net = pl.price; }
    return '<li class="cd-rec">' + thumbKey(k) + '<div class="cd-rt"><p class="cd-nm">' + esc(p.name) + '</p><p class="cd-var">' + esc(p.pack) + ' · ' + (net !== p.cents ? '<s><span class="sr">Regular </span>' + cents(p.cents) + '</s> <b>' + cents(net) + '</b>' : '<b>' + cents(p.cents) + '</b>') + '</p><p class="cd-why">' + esc(RECS.why[k]) + '</p></div>' +
      '<div class="cd-ra"><button class="btn btn-gold" type="button" data-rec="' + k + '" aria-label="' + esc(addLabel(k)) + '">+ Add</button></div></li>';
  }).join('');
  cueState(!empty && recs.length > 0);
  var a2 = anchor && $(anchor, cd);
  if (a2 && aTop !== null) cdBody.scrollTop = st + (relTop(a2) - aTop); else cdBody.scrollTop = st;
  try { document.dispatchEvent(new CustomEvent('tkr:cart', {detail:M})); } catch(e){}    /* page surfaces (collections tracker / bottom bar) */
}
$('#cdLines').addEventListener('click', function(e){
  var li = e.target.closest('.cd-line[data-key]'); if (!li) return;
  var key = li.getAttribute('data-key'), row = model().paid.filter(function(r){ return r.key === key; })[0]; if (!row) return;
  var nm = row.item ? CATALOG[row.item].name : row.line.product_title;
  var qb = e.target.closest('[data-q]');
  if (qb){
    if (qb.getAttribute('aria-busy') === 'true') return;
    var d = +qb.getAttribute('data-q'), q = Math.max(1, row.qty + d); qb.setAttribute('aria-busy', 'true');
    setQty(key, q).then(function(extra){
      draw('.cd-line[data-key="' + key + '"]');
      var r2 = model().paid.filter(function(r){ return r.item === row.item && r.sub === row.sub; })[0];
      say(nm + ' quantity ' + (r2 ? r2.qty : q) + '.' + (extra || ''));
      var nl = r2 && $('.cd-line[data-key="' + r2.key + '"]', cd), nb = nl && $('[data-q="' + d + '"]', nl);
      (nb && !nb.disabled ? nb : (nl ? $('[data-q="1"]', nl) : $('.cd-x', cd))).focus({preventScroll:true});
    });
    return;
  }
  if (e.target.closest('[data-rm]')){
    var idx = $$('.cd-line[data-key]', cd).indexOf(li);
    setQty(key, 0).then(function(extra){
      draw(null); say('Removed: ' + nm + '.' + (extra || ''));
      var rest = $$('.cd-line[data-key]', cd), next = rest[Math.min(idx, rest.length - 1)];
      (next ? $('[data-rm]', next) : ($('#cdEmpty [data-cart-shop]') || $('.cd-x', cd))).focus({preventScroll:true});
    });
  }
});
$('#cdRecs').addEventListener('click', function(e){
  var b = e.target.closest('[data-rec]'); if (!b) return;
  var k = b.getAttribute('data-rec');
  var item = (k === 'kit' && TKR.hooks && TKR.hooks.kitItem) ? TKR.hooks.kitItem() : {id:CATALOG[k].variant, quantity:1};
  add([item], b, $('#cdMsg')).then(function(ok){
    var r = ok && model().paid.filter(function(x){ return x.item === k && !x.sub; })[0];
    var t = r && $('.cd-line[data-key="' + r.key + '"] [data-q="1"]', cd);
    (t || $('.cd-x', cd)).focus({preventScroll:true});
  });
});
$('#cdCheckout').addEventListener('click', function(){
  var b = this; b.disabled = true; b.textContent = 'Checking out…';
  Q.then(function(){ location.href = root() + 'checkout'; });
});
document.addEventListener('click', function(e){ if (e.target.closest('[data-cue-go]')){ e.preventDefault(); cueGo(); } });
var rT; window.addEventListener('resize', function(){ clearTimeout(rT); rT = setTimeout(function(){ if (!cd.hidden) draw(); }, 120); });

function focusables(){ return $$('button:not([disabled]),a[href],input:not([disabled]),[tabindex]:not([tabindex="-1"])', cdPanel).filter(function(el){ return el.offsetParent !== null; }); }
function openCart(opener, msg){
  say(msg || ''); $('#cdPrev').hidden = true;
  if (!cd.hidden){ draw(); return; }
  cdOpener = opener || document.activeElement;
  draw(); cdBody.scrollTop = 0;
  cd.hidden = false; document.documentElement.classList.add('tkr-lock');
  requestAnimationFrame(function(){ cd.classList.add('open'); });
  setTimeout(function(){ var x = $('.cd-x', cd); if (x) x.focus({preventScroll:true}); cueFit(); }, 30);
}
function closeCart(){
  if (cd.hidden) return;
  cd.classList.remove('open'); document.documentElement.classList.remove('tkr-lock');
  setTimeout(function(){ cd.hidden = true; }, reduce ? 0 : 300);
  var o = cdOpener; cdOpener = null;
  if (o && document.contains(o) && o.offsetParent !== null) o.focus({preventScroll:true});
}
function toShop(){
  var t = $('#build-your-ritual');
  if (!t){ location.href = withCampaign(root() + 'collections/all'); return; }
  t.scrollIntoView({behavior: reduce ? 'auto' : 'smooth', block:'start'});
}
document.addEventListener('click', function(e){
  var o = e.target.closest('[data-cart-open], .tkg-cart, a.cart-btn');
  if (o){ e.preventDefault(); openCart(o); fetchAndDraw(); return; }
  if (e.target.closest('[data-cart-close]')){ closeCart(); return; }
  if (e.target.closest('[data-cart-shop]')){ closeCart(); setTimeout(toShop, reduce ? 0 : 320); }
});
document.addEventListener('keydown', function(e){
  if (cd.hidden) return;
  if (e.key === 'Escape'){ e.preventDefault(); closeCart(); return; }
  if (e.key === 'Tab'){
    var f = focusables(); if (!f.length) return;
    var a = f[0], z = f[f.length - 1];
    if (e.shiftKey && (document.activeElement === a || document.activeElement === cdPanel)){ e.preventDefault(); z.focus(); }
    else if (!e.shiftKey && document.activeElement === z){ e.preventDefault(); a.focus(); }
  }
});
$$('[data-open-details]').forEach(function(a){ a.addEventListener('click', function(e){
  e.preventDefault(); var d = $('#offer-details'); if (!d) return; d.open = true;
  d.scrollIntoView({behavior: reduce ? 'auto' : 'smooth', block:'center'}); $('summary', d).focus({preventScroll:true});
}); });

/* existing product-page purchase forms (tk27-*.js) dispatch tk27:cart-added after a real /cart/add.js */
document.addEventListener('tk27:cart-added', function(e){
  var before = STATE.cart ? model() : null;
  reconcile().then(function(){ var items = (e.detail && e.detail.items && (e.detail.items.items || [e.detail.items])) || [], k = items[0] && byVariant[items[0].variant_id || items[0].id];
    openCart(null, 'Added to your cart' + (k ? ': ' + CATALOG[k].name + ', ' + CATALOG[k].pack : '') + '.' + rewardDelta(before, model())); });
});
function fetchAndDraw(){ return reconcile().then(function(){ draw(); }); }
/* cart changed in another tab, or restored from back/forward cache */
document.addEventListener('visibilitychange', function(){ if (document.visibilityState === 'visible') fetchAndDraw(); });
window.addEventListener('pageshow', function(e){ if (e.persisted) fetchAndDraw(); });

window.TKR = {__v:1, data:D, campaign:C, catalog:CATALOG, add:add, open:openCart, close:closeCart, refresh:fetchAndDraw, model:model, say:say,
  kind:shopKind, offerDetails:offerDetails, unitNet:unitNet, isEligible:isEligibleKey, hooks:{}};
applyCopy(); drawShop();
fetchAndDraw();
document.dispatchEvent(new CustomEvent('tkr:ready'));
})();
